// import momenttz from "moment-timezone";
import dayjs from 'dayjs'; // Core Day.js
import utc from 'dayjs/plugin/utc.js'; // UTC plugin
import timezone from 'dayjs/plugin/timezone.js'; // Timezone plugin
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const convertMatchTime = (
  matchTime,
  format = "DD-MM-YYYY",
  tz = "Asia/Ho_Chi_Minh"
) => {
  return dayjs.unix(matchTime).tz(tz).format(format);
};
